import React, { Fragment } from "react";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import BasicSelect from "../../../components/Common/Select";
import Button from "../../../components/Common/Button";
import { axios } from "../../../helpers/axios";
import { capitalizeFirstLetter } from "../../../helpers/utils";
import { useGetEventDropdownQuery } from "../../../store/events/eventsApis";
import { PERMISSIONS } from "../../../helpers/constants";
import HasPermission from "../../../components/Common/HasPermission";

const PlayerEventBookingsReportsContainer = () => {
    const [exporting, setExporting] = React.useState(false);
    const [selectedEvent, setSelectedEvent] = React.useState(null);

    const reportType = "Player Event Bookings Reports";

    const { data: eventData } = useGetEventDropdownQuery({});

    const handleExport = async () => {
        if (!selectedEvent) {
            return;
        }

        try {
            setExporting(true);

            const hitUrl =
                `/player-reports/event-bookings-category-wise?event_id=${selectedEvent}`;

            console.log(
                "Event Category Wise Report URL:",
                hitUrl,
            );

            const response = await axios.get(hitUrl, {
                responseType: "blob",
            });

            const blob = new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = url;

            link.setAttribute(
                "download",
                "event_bookings_category_wise.xlsx",
            );

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(
                "Event category-wise report export failed:",
                error,
            );
        } finally {
            setExporting(false);
        }
    };

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between">
                    <Grid item xs={6} sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">
                            {capitalizeFirstLetter(reportType)} Reports
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container gap={2}>
                    <Fragment>
                        {/* Event */}
                        <Grid item xs={12} md={3}>
                            <BasicSelect
                                size="small"
                                value={selectedEvent || ""}
                                onChange={(e) =>
                                    setSelectedEvent(e.target.value)
                                }
                                displayEmpty
                                label="Select Event"
                                name="event_id"
                                id="event_id"
                                items={[
                                    {
                                        value: "",
                                        label: "All Events",
                                    },
                                    ...(eventData ? eventData : []),
                                ]}
                            />
                        </Grid>
                    </Fragment>
                </Grid>

                {/* Export */}
                <Grid container pt={2} justifyContent="flex-end" gap={2}>
                    <HasPermission
                        permission={PERMISSIONS.REPORTS.EVENT.EXPORT_DATA}
                        fallback={null}
                    >
                        <Button
                            size="large"
                            type="submit"
                            fullWidth={false}
                            loading={exporting}
                            onClick={handleExport}
                        >
                            Export & Download
                        </Button>
                    </HasPermission>
                </Grid>
            </Paper>
        </Stack>
    );
};

export default PlayerEventBookingsReportsContainer;